import { EarningsInsightRating } from '@toggle/toggle';
import React from 'react';

import * as S from './RatingPill.styles';
import { getRatingColors } from './utils';

export interface RatingPillProps {
  rating: EarningsInsightRating;
}

export const RatingPill = ({ rating }: RatingPillProps) => {
  const { backgroundColor, textColor } = getRatingColors(rating);

  return (
    <S.RatingWrapper $bgColor={backgroundColor}>
      <S.RatingLabel $textColor={textColor}>
        {rating
          .split(' ')
          .map(word => word[0].toUpperCase() + word.slice(1))
          .join(' ')}
      </S.RatingLabel>
    </S.RatingWrapper>
  );
};
